module.exports = __webpack_public_path__ + "static/media/menuV0.faee1905.svg";